const hex = (n) =>
  Array.from(crypto.getRandomValues(new Uint8Array(n / 2)), (b) => b.toString(16).padStart(2, '0')).join('');

export const newTraceId = () => hex(32);

// RN-07: W3C Trace Context; só propaga, o navegador não envia telemetria.
// Com traceId, mantém o trace e troca só o span (chamadas da mesma ação)
export const newTraceparent = (traceId = newTraceId()) => `00-${traceId}-${hex(16)}-01`;
